export const articleDetail = {
  id: 101,
  slug: 'wanghong-a-fangche-shijian',
  title: '某千万粉网红被实锤假慈善，背后金主身份曝光引全网哗然',
  category: '网红塌房',
  categorySlug: 'wanghong-tafang',
  heat: '98.7万',
  heatNum: 987000,
  image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20stage%20with%20dramatic%20crimson%20red%20spotlight%2C%20empty%20stage%20with%20fallen%20microphone%2C%20scandal%20and%20exposure%20mood%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20and%20black%20tones%2C%20cinematic%20wide%20composition%2C%20grainy%20film%20texture%2C%20professional%20composition%20with%20negative%20space%2C%20simple%20dark%20background&width=1200&height=600&seq=article-detail-01&orientation=landscape',
  time: '2026年7月7日 14:30',
  author: '吃瓜前线记者',
  source: '吃瓜网站线路一编辑部',
  tags: ['网红塌房', '假慈善', '资本运作', '人设崩塌'],
  content: [
    {
      type: 'paragraph',
      text: '近日，一则关于某千万粉丝级别网红假慈善的爆料在网络上引发轩然大波。据内部知情人士透露，这位长期以"公益大使"形象示人的网红，其名下所有慈善项目均为精心策划的作秀行为，背后更有神秘资本力量的操控。',
    },
    {
      type: 'heading',
      text: '慈善人设的建立',
    },
    {
      type: 'paragraph',
      text: '该网红自2024年起开始打造公益人设，先后推出了"爱心助学计划""山区儿童营养餐""流浪动物救助"等多个慈善项目，每次公益活动都会在社交平台进行大量宣传，收获了大量粉丝的好评和信任。',
    },
    {
      type: 'paragraph',
      text: '据其团队公开的数据显示，这些慈善项目累计筹集善款超过5000万元，帮助了全国20多个省份的困难群体。然而，这一切美好的表象背后，却隐藏着一个精心编织的谎言网络。',
    },
    {
      type: 'heading',
      text: '内部人士的爆料',
    },
    {
      type: 'paragraph',
      text: '一位不愿意透露姓名的前团队成员向本网爆料称：所谓慈善项目从头到尾就是一场戏。每次活动前，团队会提前安排好受助对象，这些人其实都是花钱请来的群演。捐赠的物资在拍完照片和视频后就会被收回，善款也从未真正到达需要帮助的人手中。',
    },
    {
      type: 'paragraph',
      text: '该爆料人还提供了多份内部聊天记录和转账凭证，显示所谓的公益捐款实际上在多个公司账户之间进行空转，最终回到了与该网红关联的控股公司名下。',
    },
    {
      type: 'heading',
      text: '神秘金主的浮出水面',
    },
    {
      type: 'paragraph',
      text: '随着调查的深入，一个更为复杂的关系网逐渐浮出水面。据知情人士透露，该网红背后站着一位身家数十亿的神秘资本大鳄，此人不仅为网红的慈善项目提供了"种子资金"，还通过自己的商业网络帮助网红获取了多个政府合作项目。',
    },
    {
      type: 'paragraph',
      text: '这位神秘金主的身份在爆料中引发了更多猜测。有分析认为，此人正是某知名投资集团的幕后控制人，通过网红的公益人设来为自己洗白形象，同时获取更多的社会资源和政府关系。',
    },
    {
      type: 'heading',
      text: '各方的反应',
    },
    {
      type: 'paragraph',
      text: '爆料发出后，该网红的社交账号评论区内一片哗然。大量粉丝表示"不敢相信""原来一切都是假的"，也有不少之前就质疑过该网红的网友表示"终于有人曝光了"。',
    },
    {
      type: 'paragraph',
      text: '多个与该网红有合作关系的品牌方已经紧急发布声明，表示将暂停与该网红的所有合作，并保留追究其违约责任的权利。某知名公益基金会也表示，将配合相关部门对涉及该网红的合作项目进行全面审计。',
    },
    {
      type: 'heading',
      text: '法律层面的分析',
    },
    {
      type: 'paragraph',
      text: '法律专家指出，如果爆料内容属实，该网红及其团队的行为可能涉嫌多项违法。首先是慈善领域的虚假宣传和欺诈行为，其次如果涉及善款挪用，还可能构成侵占罪或诈骗罪。',
    },
    {
      type: 'paragraph',
      text: '另外，如果其背后的资本运作涉及洗钱等行为，相关的刑事责任将会更加严重。目前，已经有律师表示愿意为受骗的捐款者提供法律援助，集体诉讼的准备工作正在展开。',
    },
    {
      type: 'heading',
      text: '总结与反思',
    },
    {
      type: 'paragraph',
      text: '这起事件再次敲响了警钟：在网红经济高速发展的今天，公众需要保持理性和警惕。网红人设可以精心包装，但真相终将浮出水面。同时也呼吁相关部门加强对网络慈善行为的监管，让真正需要帮助的人得到应有的关怀。',
    },
    {
      type: 'paragraph',
      text: '本网将持续关注此事件的后续发展，为读者带来最新的调查进展。同时也欢迎知情人士通过本网匿名爆料通道提供更多线索。',
    },
  ],
};

export const articleComments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20person%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    username: '热心网友小王',
    time: '30分钟前',
    rating: 5,
    content: '太震惊了！一直关注这个网红的公益活动，没想到全是演戏。这种欺骗大众感情的行为真的太恶劣了，希望能严惩！',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Asian%20woman%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    username: '理性看世界',
    time: '1小时前',
    rating: 4,
    content: '我之前就怀疑过他的慈善项目数据水分太大，一个网红怎么可能募集到这么多善款？现在看来果然有问题。',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    username: '法律观察员',
    time: '2小时前',
    rating: 5,
    content: '从法律角度看，如果善款确实被挪用，这可能涉及刑事犯罪。建议受骗的捐款者保留好捐款凭证，配合警方调查。',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
    username: '公益圈内人',
    time: '3小时前',
    rating: 4,
    content: '做公益真的不是请客吃饭，需要真心实意。这种打着公益旗号圈钱的人，不仅伤害了捐款者的感情，更让真正做公益的人受到了牵连。',
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%2040s%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-05&orientation=squarish',
    username: '深度调查记者',
    time: '4小时前',
    rating: 5,
    content: '作为从业多年的调查记者，我认为这件事背后还有更多值得深挖的地方。那个神秘金主的身份才是最关键的线索，希望能看到更多实质性进展。',
  },
  {
    id: 6,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20in%2030s%2C%20simple%20studio%20lighting%2C%20neutral%20warm%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-06&orientation=squarish',
    username: '吃瓜路人人',
    time: '5小时前',
    rating: 3,
    content: '说实话现在的网红圈真的太乱了，今天这个塌房明天那个翻车。不过这个瓜确实够大，期待后续发展！',
  },
];

export const relatedArticles = [
  {
    id: 201,
    slug: 'wanghong-b-gongguan-weiji',
    title: '百万粉美妆博主抄袭事件升级：原创者发律师函，品牌方集体解约',
    category: '网红塌房',
    heat: '54.3万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20beauty%20studio%20scene%20in%20disarray%2C%20scattered%20cosmetics%2C%20dramatic%20crimson%20side%20lighting%2C%20scandal%20atmosphere%2C%20editorial%20photography%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=600&height=400&seq=related-01&orientation=landscape',
    time: '3小时前',
  },
  {
    id: 202,
    slug: 'heike-wanghong-zhapian',
    title: '又一个带货网红翻车：被指售卖假冒保健品，受害者已超千人',
    category: '网红塌房',
    heat: '48.1万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20scattered%20supplement%20bottles%2C%20crimson%20warning%20light%2C%20consumer%20fraud%20concept%2C%20editorial%20photography%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20cinematic%20look%2C%20simple%20gradient%20background%2C%20professional%20composition&width=600&height=400&seq=related-02&orientation=landscape',
    time: '6小时前',
  },
  {
    id: 302,
    slug: 'ziben-jiaoyi-jiemi',
    title: '某MCN机构黑幕曝光：通过数据造假骗取投资超五千万',
    category: '黑料吃瓜',
    heat: '66.2万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20corporate%20scene%20with%20scattered%20documents%20and%20money%2C%20dramatic%20crimson%20backlight%2C%20fraud%20theme%2C%20editorial%20photography%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=600&height=400&seq=related-03&orientation=landscape',
    time: '9小时前',
  },
];

export const allArticlesMap: Record<string, typeof articleDetail> = {
  'wanghong-a-fangche-shijian': articleDetail,
};